import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { organizationsAPI } from '../../api/organizations';
import { Button, Card, Input, Textarea, Alert, PageLayout, PageHeader } from '../ui';

export const CreateOrganization: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      setError('Organization name is required');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const org = await organizationsAPI.create(formData);
      navigate(`/organizations/${org.id}`);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Failed to create organization');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageLayout maxWidth="sm">
      <PageHeader
        title="Create New Organization"
        backTo="/organizations"
        backLabel="Organizations"
      />

      <Card elevated>
        {error && (
          <Alert variant="error" className="mb-4">{error}</Alert>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            id="name"
            label="Organization Name"
            required
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="Enter organization name"
          />

          <Textarea
            id="description"
            label="Description"
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            rows={4}
            placeholder="Enter organization description (optional)"
          />

          <div className="flex gap-4 pt-4">
            <Button
              type="submit"
              loading={loading}
              fullWidth
            >
              {loading ? 'Creating...' : 'Create Organization'}
            </Button>
            <Button
              type="button"
              variant="secondary"
              onClick={() => navigate('/organizations')}
              fullWidth
            >
              Cancel
            </Button>
          </div>
        </form>
      </Card>
    </PageLayout>
  );
};